<template>
  <div>
    <!-- Sidebar -->
    <div class="sidebar waajo-nav-sidebar" id="sidebar">
      <vue-custom-scrollbar
        class="scroll-area"
        :settings="settings"
        @ps-scroll-x="scrollHanle"
      >
        <div
          class="sidebar-menu d-flex flex-column justify-content-between h-100"
        >
          <ul>
            <li class="index">
              <router-link to="/index">
                <i class="la la-home"></i>
                <span>Back to Home</span>
              </router-link>
            </li>
            <li class="menu-title">Addons ChatBot</li>
            <li
              v-for="item in listMenu"
              :key="item.name"
              class="settings"
              :class="{ active: currentpage === item.name }"
            >
              <router-link :to="item.link">
                <i :class="item.icon"></i>
                <span>{{ item.title }}</span>
              </router-link>
            </li>
            <li class="menu-title">Balasan Otomatis</li>
            <li
              class="settings"
              :class="{ active: ['agentAiV2List', 'agentAiV2Create', 'agentAiV2Edit', 'agentAiV2Simulation'].indexOf(currentpage) !== -1 }"
            >
              <router-link to="/agent-ai-v2">
                <img
                  src="@/assets/agent-ai/agent-ai-menu.png"
                  class="agent-ai-menu-icon"
                  alt=""
                  aria-hidden="true"
                />
                <span>Agent AI &amp; Chatbot</span>
              </router-link>
              
            </li>
            <li
              class="settings"
              :class="{ active: ['/ai/historykb'].indexOf(currentpage) !== -1 }"
            >
                 <router-link class="la la-book" to="/ai/historykb">
                <span>Knowledge Base</span>
              </router-link>
            </li>
            <!-- <li class="menu-title">Agent AI &amp; Chatbot</li> -->
            <li
              v-for="item in listMenuAIChatbot"
              :key="item.name"
              class="settings"
              :class="{ active: currentpage === item.name }"
            >
              <router-link :to="item.link">
                <i :class="item.icon"></i>
                <span>{{ item.title }}</span>
              </router-link>
            </li>
            <li class="menu-title" v-if="!showRegister">
              Pengaturan AI &amp; Statistik
            </li>
            <li class="menu-title" v-else>Fitur AI</li>
            <template v-for="item in listMenuAI">
              <template v-if="item.show">
                <li
                  :key="item.name"
                  class="settings"
                  :class="{ active: currentpage === item.name }"
                >
                  <router-link :to="item.link">
                    <i :class="item.icon"></i>
                    <span>{{ item.title }}</span>
                  </router-link>
                </li>
              </template>
            </template>
          </ul>
          <div
            v-if="showRegister == true"
            class="card border-0 shadow-sm ai-sidebar-card"
          >
            <div class="card-body p-4">
              <!-- Title -->
              <h6 class="font-weight-bold mb-2">Aktifkan AI di Chatbot Anda</h6>

              <!-- Description -->
              <p class="text-muted small mb-3">
                Balas pesan pelanggan lebih cerdas dan otomatis. AI memahami
                pertanyaan dan menjawab berdasarkan Knowledge Base Anda.
              </p>

              <!-- CTA -->
              <router-link
                to="/ai-chat/overview"
                class="btn btn-dark btn-block"
              >
                <span class="mr-2 text-success">
                  <i class="fa fa-circle"></i>
                </span>
                Coba Fitur AI
              </router-link>
            </div>
          </div>
        </div>
      </vue-custom-scrollbar>
    </div>
    <!-- Sidebar -->
  </div>
</template>
<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
export default {
  components: {
    vueCustomScrollbar,
  },
  computed: {
    currentpage() {
      return this.$route.name;
    },
    isJoinAffiliate() {
      return this.$store.state.referral.isJoin;
    },
    aiBalance() {
      return this.$store.state.aiKey.aiBalance;
    },
    listMenuAI() {
      const showAIMenu =
        this.aiBalance && this.aiBalance.is_available == true ? true : false;
      return [
        {
          title: "Overview",
          show: true,
          link: "/ai-chat/overview",
          name: "ai_chat_overview",
          icon: "la la-line-chart",
        },
        {
          title: "Daftar Sesi",
          show: showAIMenu,
          link: "/aikey",
          name: "settings_aikey",
          icon: "la la-key",
        },
        {
          title: "Rangkuman AI",
          show: showAIMenu,
          link: "/aisummary",
          name: "ai_summary",
          icon: "la la-sitemap",
        },
        {
          title: "Workflow AI",
          show: showAIMenu,
          link: "/ai/workflow",
          name: "ai_workflow",
          icon: "la la-globe",
        },
        // {
        //   title: "Knowledge Base",
        //   show: showAIMenu,
        //   link: "/ai/historykb",
        //   name: "ai_historykb",
        //   icon: "la la-book",
        // },
        {
          title: "Topup Token AI",
          show: showAIMenu,
          link: "/ai/pricing",
          name: "ai_pricing",
          icon: "fa fa-credit-card",
        },
      ];
    },
  },
  watch: {
    aiBalance(val) {
      console.log(val);
    },
  },
  data() {
    return {
      settings: {
        suppressScrollX: false,
      },
      showRegister: false,
      listMenu: [
        {
          title: "Overview",
          link: "/ai-chatbot/overview",
          name: "ai_chatbot_overview",
          icon: "la la-line-chart",
        },
        {
          title: "Text Reply",
          link: "/automation/text-reply/list",
          name: "textReplyList",
          icon: "la la-file-text",
        },

        {
          title: "Reply Keyword",
          link: "/automation/custom-by-keywords-chat/list",
          name: "customByKeywords",
          icon: "la la-search",
        },
        {
          title: "Alur Percakapan",
          link: "/automation/custom-rules-text/list",
          name: "customRulesText",
          icon: "la la-sitemap",
        },
      ],
      listMenuAIChatbot: [
        // {
        //   title: "Balas Otomatis",
        //   link: "/automation/welcome-chat/list",
        //   name: "welcomeChatList",
        //   icon: "la la-refresh",
        // },
        // {
        //   title: "Balas di Jam Kerja",
        //   link: "/automation/working-chat/list",
        //   name: "workingChatList",
        //   icon: "la la-clock-o",
        // },
        // {
        //   title: "Balas Diluar Jam Kerja",
        //   link: "/automation/away-chat/list",
        //   name: "awayChatList",
        //   icon: "la la-moon-o",
        // },
      ],
      // listMenuAI:
      activeClass: "active",
    };
    //  isactive : true
  },
  created() {
    this.getBalance();
  },
  methods: {
    getBalance() {
      // console.log("geetttt")
      // if (this.aiBalance !== null) return;
      try {
        this.isLoading = true;
        this.$store
          .dispatch("aiKey/getBalance")
          .then((response) => {
            this.isLoading = false;
            // let { data } = response;
            // this.aiBalance = data;
            // if (this.aiBalance.is_available == true) {
            //   // console.log;
            //   this.listMenuAI.forEach((item) => {
            //     item.show = true;
            //     this.showRegister = false;
            //   });
            // } else {
            //   this.showRegister = true;
            // }
          })
          .catch((err) => {
            // console.log("errr",err)
            this.showRegister = true;

            this.isLoading = false;
          });
      } catch (error) {
        this.showRegister = true;
        this.isLoading = false;
      }
    },
    scrollHanle(evt) {
      console.log(evt);
    },
  },
};
</script>
<style>
.scroll-area {
  position: relative;
  margin: auto;
  height: calc(100vh - 60px);
  background-color: transparent !important;
}
.sidebar {
  height: 100vh;
  overflow: auto;
}

.sidebar::-webkit-scrollbar {
  width: 7px;
}

/* Track */
.sidebar::-webkit-scrollbar-track {
  /* box-shadow: inset 0 0 5px grey;  */
  box-shadow: none;
  border-radius: 10px;
}

/* Handle */
.sidebar::-webkit-scrollbar-thumb {
  /* background: red;  */
  border-radius: 10px;
  /* background: rgb(204, 204, 204); */
  background-color: transparent;
}

/* Handle on hover */
.sidebar::-webkit-scrollbar-thumb:hover {
  /* background: #b30000;  */
  background: rgb(204, 204, 204);
}
.sidebar-menu ul ul a.class-active {
  color: #00c5fb;
  text-decoration: underline;
}
.agent-ai-menu-icon {
  display: inline-block;
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  object-fit: contain;
  vertical-align: middle;
}
@media (min-width: 768px) {
  .mini-sidebar .agent-ai-menu-icon {
    flex-basis: 30px;
    width: 30px;
    height: 30px;
  }
  .mini-sidebar.expand-menu .agent-ai-menu-icon {
    flex-basis: 20px;
    width: 20px;
    height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/SidebarChatbot.vue